"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24GlobeLine = function Svg24GlobeLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm.015-2.003L12 20l-.015-.003a.292.292 0 0 1-.066-.032 1.235 1.235 0 0 1-.301-.291c-.26-.33-.539-.87-.79-1.626-.43-1.29-.732-3.05-.809-5.048h3.962c-.076 1.997-.378 3.757-.808 5.048-.252.756-.53 1.296-.79 1.626a1.235 1.235 0 0 1-.302.29.292.292 0 0 1-.066.033zM13.981 11h-3.962c.076-1.997.378-3.757.808-5.048.252-.756.53-1.296.79-1.626.128-.162.232-.248.302-.29a.295.295 0 0 1 .066-.033L12 4s.006 0 .015.003a.295.295 0 0 1 .066.032c.07.043.174.13.301.291.26.33.539.87.79 1.626.43 1.29.732 3.05.809 5.048zm2.001 2c-.077 2.174-.404 4.155-.912 5.68-.096.29-.201.568-.315.833A8.009 8.009 0 0 0 19.938 13h-3.956zm3.956-2h-3.956c-.077-2.174-.404-4.156-.912-5.68-.096-.29-.201-.568-.315-.833A8.009 8.009 0 0 1 19.938 11zm-11.92 0c.077-2.174.404-4.156.912-5.68.096-.29.201-.568.315-.833A8.009 8.009 0 0 0 4.062 11h3.956zm-3.956 2a8.009 8.009 0 0 0 5.183 6.513 10.591 10.591 0 0 1-.315-.833c-.508-1.524-.835-3.506-.912-5.68H4.062z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24GlobeLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24GlobeLine;
exports.default = _default;